import context from '@truckdown/components-systems';
import registerAnalysis from '@truckdown/analysis';
import registerAccounts from '@truckdown/accounts';

import './Components';
import './Style/Logging/main.less';

import './Images/appicon.png';
import './Images/pixel.png';
import './Images/app_icon_512.png';
import './Images/app_icon_192.png';
import './Images/app-icon.svg';

registerAnalysis(context);
registerAccounts(context);

context.initialize().then(() => {
    console.log('System initialized');
});